import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=47fe6b70&scoped=true&"
import script from "./TagSelect.vue?vue&type=script&lang=js&"
export * from "./TagSelect.vue?vue&type=script&lang=js&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=47fe6b70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe6b70",
  null
  
)

export default component.exports